import { Link } from "react-router-dom";
import Seo from "@/components/feature/Seo";
import Breadcrumb, { type Crumb } from "@/components/feature/Breadcrumb";

const team = [
  {
    name: "编辑部",
    role: "内容策划与深度报道",
    desc: "负责选题策划、事实核查与深度稿件撰写，坚持多信源交叉验证。",
    icon: "ri-quill-pen-line",
  },
  {
    name: "线索组",
    role: "24 小时爆料接收",
    desc: "多渠道收集读者线索，第一时间跟进核实，把零散信息拼成完整拼图。",
    icon: "ri-radar-line",
  },
  {
    name: "数据组",
    role: "事实核查与可视化",
    desc: "用数据还原事件脉络，让每一篇报道都经得起推敲与回看。",
    icon: "ri-bar-chart-2-line",
  },
];

const guidelines = [
  "本站内容以公开信息与读者线索为基础整理呈现，具体政策与处置结果请以官方发布为准。",
  "鼓励理性讨论，禁止发布人身攻击、造谣传谣及侵犯他人隐私的内容。",
  "转载本站原创内容请注明来源“51爆料”，商业使用需取得授权。",
  "如对内容有异议或需要更正，欢迎通过联系反馈页与我们沟通。",
];

export default function AboutPage() {
  const crumbs: Crumb[] = [{ label: "关于我们" }];

  return (
    <div className="bg-background-50">
      <Seo
        title="关于我们 - 51爆料热点爆料平台"
        description="了解 51爆料：一家聚焦社会、娱乐、科技热点的资讯爆料平台，坚持事实底线与多元视角。"
        keywords="51爆料,关于我们,爆料平台,新闻资讯"
      />

      <div className="bg-primary-500 text-white">
        <div className="max-w-7xl mx-auto w-full px-4 md:px-6 py-10 md:py-14">
          <h1 className="text-2xl md:text-4xl font-heading font-black">
            关于 51爆料
          </h1>
          <p className="mt-3 text-sm md:text-base text-white/85 max-w-2xl">
            我们相信，普通人也有权知道正在发生什么，以及它为什么发生。
          </p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto w-full px-4 md:px-6 py-6">
        <Breadcrumb items={crumbs} />
      </div>

      <div className="max-w-7xl mx-auto w-full px-4 md:px-6 pb-16">
        <section className="bg-background-50 border border-background-200 rounded-lg p-6 md:p-10">
          <h2 className="text-xl md:text-2xl font-heading font-black text-foreground-950">
            网站定位
          </h2>
          <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
            51爆料是一家聚焦社会热点、娱乐八卦、科技前沿的资讯爆料平台。我们不追逐流量的喧哗，而是希望用扎实的核实与多维的视角，帮助读者穿透信息迷雾，看清事件背后的脉络。
          </p>
          <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">
            内容覆盖 <strong className="text-foreground-900">社会</strong>、
            <strong className="text-foreground-900">娱乐</strong>、
            <strong className="text-foreground-900">科技</strong>
            三大主频道，并通过专题合集把零散的热点串联成可读、可回看的知识脉络。
          </p>

          <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mt-8">
            {[
              { num: "3+", label: "核心频道" },
              { num: "4", label: "精选专题" },
              { num: "100+", label: "深度报道" },
              { num: "50万+", label: "月浏览人次" },
            ].map((s) => (
              <div
                key={s.label}
                className="bg-background-100 rounded-lg p-4 text-center"
              >
                <p className="text-xl md:text-3xl font-heading font-black text-primary-600">
                  {s.num}
                </p>
                <p className="text-xs md:text-sm text-foreground-500 mt-1">
                  {s.label}
                </p>
              </div>
            ))}
          </div>
        </section>

        <section className="mt-10">
          <h2 className="text-xl md:text-2xl font-heading font-black text-foreground-950">
            运营团队
          </h2>
          <p className="text-sm text-foreground-500 mt-1">
            一支小而专注的内容团队（示例介绍）
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5 mt-5">
            {team.map((m) => (
              <div
                key={m.name}
                className="bg-background-50 border border-background-200 rounded-lg p-5"
              >
                <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-700 text-2xl">
                  <i className={m.icon} />
                </div>
                <h3 className="mt-4 text-lg font-heading font-bold text-foreground-950">
                  {m.name}
                </h3>
                <p className="text-sm text-primary-600 mt-0.5">{m.role}</p>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
                  {m.desc}
                </p>
              </div>
            ))}
          </div>
        </section>

        <section className="mt-10 bg-accent-50 border border-accent-200 rounded-lg p-6 md:p-8">
          <h2 className="text-xl md:text-2xl font-heading font-black text-foreground-950">
            版权声明与使用指南
          </h2>
          <ul className="mt-4 space-y-3">
            {guidelines.map((g) => (
              <li key={g} className="flex gap-3 text-sm text-foreground-700 leading-relaxed">
                <i className="ri-checkbox-circle-line text-accent-600 text-lg shrink-0" />
                {g}
              </li>
            ))}
          </ul>
          <p className="mt-6 text-xs text-foreground-400">
            © 2026 51爆料。本站为演示性质资讯站点，内容仅供浏览参考。
          </p>
        </section>

        <div className="mt-10 flex flex-wrap items-center gap-4">
          <Link
            to="/contact"
            className="px-5 py-2.5 rounded-md bg-primary-500 hover:bg-primary-600 text-white text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
          >
            联系与反馈
          </Link>
          <Link
            to="/"
            className="px-5 py-2.5 rounded-md border border-background-300 hover:border-primary-400 text-sm text-foreground-700 transition-colors cursor-pointer whitespace-nowrap"
          >
            返回首页
          </Link>
        </div>
      </div>
    </div>
  );
}